import React, {PropTypes, Component} from 'react'
import classnames from 'classnames'

class ClassDateTd extends Component {
  constructor(props){
    super(props)
  }

  static propTypes = {
    classInfo: PropTypes.object.isRequired
  }


  render(){
    let {classInfo} = this.props
    let {
      earliest_date,
      latest_date,
    } = classInfo;

    return(
      <div className='class-date'>
        {(earliest_date && latest_date) && <span>{earliest_date} - {latest_date}</span>}
      </div>
    )
  }
}


export default ClassDateTd



// WEBPACK FOOTER //
// ./src/containers/pages/Class/ClassTable/ClassDateTd.js